import React from "react";


export default function UpdateVehicleAccessory(){
return(

    <div className="updatevehicleaccessory-container my-4">
        <div className="col-md-12">      
              <div className="special-header">
            <div className="page-title">Update Vehicle Accessory</div>
        </div>
             <form>
                    <div className="row update-vehicle-accessory">
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="vehiycleno" className="form-label"> Vehicle Number <span className="text-danger">*</span></label>
                            <select id="vehicleno" className="form-control updatevehicleaccessory-form-select" >
                                <option>Select</option>
                                <option>New Vehicle</option>
                                <option>MH02WE0002</option>
                                <option>MH02YE0902</option>
                            </select>
                        </div>
                        
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="item" className="form-label"> Accessory Item <span className="text-danger">*</span>  </label>
                            <input type="text" id="item" className="form-control updatevehicleaccessory-form-control" />
                        </div>


                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="quantity" className="form-label"> Quantity <span className="text-danger">*</span>  </label>
                            <input type="text" id="quantity" className="form-control updatevehicleaccessory-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="price" className="form-label">Price<span className="text-danger">*</span> </label>
                            <input type="text" id="price" className="form-control updatevehicleaccessory-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="purchasefrom" className="form-label">Purchase From<span className="text-danger">*</span></label>
                            <input type="text" id="purchasefrom" className="form-control updatevehicleaccessory-form-control" />
                        </div>

                         <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="purchasedate" className="form-label">Purchase Date<span className="text-danger">*</span></label>
                            <input type="date" id="purchasedate" className="form-control updatevehicleaccessory-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="invoice" className="form-label">Invoice<span className="text-danger">*</span></label>
                            <input type="file" id="purchasedate" className="form-control updatevehicleaccessory-form-control" />
                        </div>

                        <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
                            <button to="/" type="submit" className="btn custom-btn">Update</button>
                        </div>
                    </div>
                </form>
    </div>
    </div>

);
}

